import React from 'react';

interface SecuritySettingsProps {
    name: string;
    email: string;
    onChangeName: () => void;
    onChangePassword: () => void;
}

const SecuritySettings: React.FC<SecuritySettingsProps> = ({
    name,
    email,
    onChangeName,
    onChangePassword
}) => (
    <div className="flex flex-col gap-4">
        <div className="flex items-center justify-between">
            <div className="flex flex-col gap-1">
                <span className="text-sm font-semibold text-[#6B7280]">Name</span>
                <span className="text-gray-800">{name || '—'}</span>
            </div>
            <button
                onClick={onChangeName}
                className="px-4 py-2 text-sm font-semibold text-gray-800 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
                Edit name
            </button>
        </div>

        <div className="flex flex-col gap-1">
            <span className="text-sm font-semibold text-[#6B7280]">Email</span>
            <span className="text-gray-800">{email}</span>
        </div>

        <div className="flex items-center justify-between">
            <div className="flex flex-col gap-1">
                <span className="text-sm font-semibold text-[#6B7280]">Password</span>
                <span className="text-gray-800">••••••••</span>
            </div>
            <button
                onClick={onChangePassword}
                className="px-4 py-2 text-sm font-semibold text-gray-800 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
                Set new password
            </button>
        </div>
    </div>
);

export default SecuritySettings;
